/**
 * This is a mapping of job statuses to their corresponding ids in the ms2_job_status table.
 * This is used to disable the JRF submission step in the job interest form if the job status id is 
 * one amongst the followinig.
 */
export const closedJobStatuses = {
    LOST_OPPORTUNITY___DEPRECATED: 14,
    LOST: 60,
    PROJECT_ABORTED: 49,
    PAUSED: 47,
    PROJECT_SUCCESSFULLY_COMPLETED: 50,
    RESOURCE_CHOSEN: 52
}

